import React from 'react';
export function HomeHeroForm() {
  return <form id="hero-form" action="/thank-you-free-trial" method="get" className="bg-paper p-8 rounded-2xl shadow-xl border border-subtle-gray w-full max-w-md mx-auto scroll-mt-24" data-id="element-1691">
      <h2 className="text-2xl text-ink mb-2" data-id="element-1692">
        Find the Right Class or Program
      </h2>
      <p className="text-sm text-gray-warm mb-6 leading-relaxed" data-id="element-1693">
        We'll help you choose the best starting class or program before your
        first visit.
      </p>

      <div className="flex flex-col gap-5 mb-6" data-id="element-1694">
        <div data-id="element-1695">
          <label htmlFor="heroFullName" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-1696">
            Full Name
          </label>
          <input type="text" id="heroFullName" required className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" placeholder="Parent or Student Name" data-id="element-1697" />
        </div>

        <div data-id="element-1698">
          <label htmlFor="heroPhone" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-1699">
            Phone Number
          </label>
          <input type="tel" id="heroPhone" required className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" placeholder="(517) 220-0621" data-id="element-1700" />
        </div>

        <div data-id="element-1701">
          <label htmlFor="heroEmail" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-1702">
            Email Address
          </label>
          <input type="email" id="heroEmail" required className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" placeholder="email@example.com" data-id="element-1703" />
        </div>

        <div data-id="element-1704">
          <label htmlFor="heroInterest" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-1705">
            Interested In
          </label>
          <select id="heroInterest" required defaultValue="" className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all appearance-none" data-id="element-1706">
            <option value="" disabled data-id="element-1707">
              Select a program
            </option>
            <option value="mini-troopers" data-id="element-1708">Mini Troopers</option>
            <option value="kids-taekwondo" data-id="element-1709">Kids Taekwondo</option>
            <option value="adult-classes" data-id="element-1710">Adult Classes</option>
            <option value="family-classes" data-id="element-1711">Family Classes</option>
            <option value="self-defense" data-id="element-1712">Self-Defense</option>
            <option value="competition-team" data-id="element-1713">Competition Team</option>
            <option value="summer-camp" data-id="element-1714">Summer Camp</option>
          </select>
        </div>
      </div>

      <button type="submit" className="btn-primary w-full mb-4" data-id="element-1715">
        Check Availability
      </button>

      <p className="text-xs text-gray-warm text-center leading-relaxed" data-id="element-1716">
        New students can start with a free week before deciding.
      </p>
    </form>;
}